"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.experimentEvalFilterColumns = void 0;
exports.experimentEvalFilterColsWithOptions = experimentEvalFilterColsWithOptions;
const typeHelpers_1 = require("../../tableDefinitions/typeHelpers");
const filterFields_1 = require("./filterFields");
exports.experimentEvalFilterColumns = [
    filterFields_1.evalFilterFields.experimentDatasetId,
];
function experimentEvalFilterColsWithOptions(options, cols = exports.experimentEvalFilterColumns) {
    return cols.map((col) => {
        if (col.id === "experimentDatasetId") {
            return (0, typeHelpers_1.formatColumnOptions)(col, options?.experimentDatasetId ?? []);
        }
        return col;
    });
}
